import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _typeof from "@babel/runtime/helpers/esm/typeof";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Description:
 * @Author: suzyli
 * @Date: 2020-03-24 14:40:01
 * @LastEditTime: 2020-08-31 15:37:33
 */

/* global msdkShare */
import Request from '../../common/network';

var isiOS = function isiOS() {
  return (/iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) && !window.MSStream;
};

var msdkCall = function msdkCall(data) {
  if (isiOS()) {
    window.msdkiOSHandler('MSDKCall', data, null);
  } else {
    if (data.indexOf('nativeCallJS') > -1) {
      console.log("msdkCall invoked nativeCallJS : ".concat(data));
      alert(data);
    } else {
      console.log("msdkCall invoked : ".concat(data));
      prompt(data);
    }
  }
};

var msdkClient = {
  jsApi: 'https://img.ssl.msdk.qq.com/wiki/msdkJsAdapter.js',
  opts: {
    title: document.title,
    // 分享标题
    desc: '',
    // 分享活动简介
    withPop: true
  },
  share: function share(opt) {
    if (_typeof(opt) === 'object') {
      if (typeof opt.withPop !== 'boolean' || opt.withPop) {
        opt.withPop = true;
      }

      this.opts = _objectSpread(_objectSpread({}, this.opts), opt);
    }

    var self = this;
    var agent = navigator.userAgent;

    if (/MSDK\/5/i.test(agent)) {
      // msdk v5
      if (!self.opts.paramsV5) {
        alert('请输入msdk分享参数');
        return;
      }

      if (!self.opts.withPop) {
        if (!self.opts.paramsV5.channel || !self.opts.paramsV5.MsdkMethod) {
          alert('请指定分享类型');
          return;
        }

        var shareData = {
          MsdkMethod: self.opts.paramsV5.MsdkMethod,
          channel: self.opts.paramsV5.channel || 'QQ',
          actionReport: 'MSG_INVITE',
          desc: self.opts.paramsV5.desc || '',
          link: self.opts.paramsV5.link || location.href,
          messageExt: 'messageExt',
          tailLogo: 'WECHAT_SNS_JUMP_APP',
          thumbPath: self.opts.paramsV5.imgUrl || '',
          title: self.opts.paramsV5.title || '',
          type: 10001,
          user: ''
        };
        msdkCall(JSON.stringify(shareData));
        return;
      }

      self.popShareWin('v5');
    } else {
      try {
        Request.loadScript(this.jsApi).then(function () {
          if (typeof msdkShare !== 'function') {
            return;
          }

          if (!self.opts.withPop) {
            if (!self.opts.MsdkMethod || !self.opts.scene) {
              alert('请指定分享类型');
              return;
            }

            var _shareData = {
              MsdkMethod: self.opts.msdkMethod,
              scene: self.opts.scene,
              title: self.opts.title,
              desc: self.opts.desc,
              url: self.opts.link
            };
            msdkShare(JSON.stringify(_shareData));
            return;
          }

          self.popShareWin();
        });
      } catch (e) {//
      }
    }
  },
  popShareWin: function popShareWin(version) {
    var self = this;
    var msdkShareContainer = document.getElementById('msdkShareContainer'); // 修复getElementById取length的bug

    if (msdkShareContainer) {
      msdkShareContainer.style.display = 'block';
      return;
    }

    var tpl = '<div id="msdkShareContainer" style="position:fixed;bottom:0;left:0;width:100%;height:100%;backgroundColor:rgba(0,0,0,.5)">\
                <div id="msdkShareWin" style="position:fixed;bottom:0;left 0;width:100%;padding: 20px 20px 25px 20px;display:flex;backgroundColor:rgba(245,244,244,1);borderRadius:15px 15px 0 0;justifyContent:space-between;boxSizing:border-box">\
                <div id="toWxTalk" class="shareButton" style="text-align:center;font-size:14px">\
                    <div class="logo" style="width:50px;height:50px;background-color:#fff;border-radius:10px;display:flex;justify-content:center;align-items:center;margin-bottom:6px">\
                        <img src="https://ossweb-img.qq.com/images/milo/share/share_wechat.png" width="30px"/>\
                    </div>\
                    <div>微信</div>\
                </div>\
                <div id="toWxMoments" class="shareButton" style="text-align:center;font-size:14px">\
                    <div class="logo" style="width:50px;height:50px;background-color:#fff;border-radius:10px;display:flex;justify-content:center;align-items:center;margin-bottom:6px">\
                        <img src="https://ossweb-img.qq.com/images/milo/share/share_moments.png" width="40px"/>\
                    </div>\
                    <div>朋友圈</div>\
                </div>\
                <div id="toQQTalk" class="shareButton" style="text-align:center;font-size:14px">\
                    <div class="logo" style="width:50px;height:50px;background-color:#fff;border-radius:10px;display:flex;justify-content:center;align-items:center;margin-bottom:6px">\
                        <img src="https://ossweb-img.qq.com/images/milo/share/share_qq.png" width="30px"/>\
                    </div>\
                    <div>QQ</div>\
                </div>\
                <div id="toQQSpace" class="shareButton" style="text-align:center;font-size:14px">\
                    <div class="logo" style="width:50px;height:50px;background-color:#fff;border-radius:10px;display:flex;justify-content:center;align-items:center;margin-bottom:6px">\
                        <img src="https://ossweb-img.qq.com/images/milo/share/share_space.gif" width="30px"/>\
                    </div>\
                    <div>QQ空间</div>\
                </div>\
                </div>\
            </div>';
    var container = document.createElement('div');
    container.innerHTML = tpl;
    document.getElementsByTagName('body')[0].appendChild(container);
    msdkShareContainer = document.getElementById('msdkShareContainer');
    msdkShareContainer.addEventListener('click', function () {
      msdkShareContainer.style.display = 'none';
    }, false);
    var shareButton = Array.from(document.getElementsByClassName('shareButton'));

    if (version == 'v5') {
      shareButton.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          var targetId = e.currentTarget.id;
          var msdkMethod;
          var channel;

          if (targetId === 'toWxTalk') {
            msdkMethod = 'sendMsgWebView';
            channel = 'WeChat';
          } else if (targetId === 'toWxMoments') {
            msdkMethod = 'shareWebView';
            channel = 'WeChat';
          } else if (targetId === 'toQQTalk') {
            msdkMethod = 'sendMsgWebView';
            channel = 'QQ';
          } else if (targetId === 'toQQSpace') {
            msdkMethod = 'shareWebView';
            channel = 'QQ';
          }

          var shareData = {
            MsdkMethod: msdkMethod,
            channel: channel,
            actionReport: 'MSG_INVITE',
            desc: self.opts.paramsV5.desc || '',
            link: self.opts.paramsV5.url || location.href,
            messageExt: 'messageExt',
            tailLogo: 'WECHAT_SNS_JUMP_APP',
            thumbPath: self.opts.paramsV5.imgUrl || '',
            title: self.opts.paramsV5.title || '',
            type: 10001,
            user: ''
          };
          msdkCall(JSON.stringify(shareData));
        });
      });
    } else {
      shareButton.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          var targetId = e.currentTarget.id;
          var msdkMethod;
          var scene;

          if (targetId === 'toWxTalk') {
            msdkMethod = 'WGSendToWeiXinWithUrl';
            scene = 0;
          } else if (targetId === 'toWxMoments') {
            msdkMethod = 'WGSendToWeiXinWithUrl';
            scene = 1;
          } else if (targetId === 'toQQTalk') {
            msdkMethod = 'WGSendToQQ';
            scene = 2;
          } else if (targetId === 'toQQSpace') {
            msdkMethod = 'WGSendToQQ';
            scene = 1;
          }

          var shareData = {
            MsdkMethod: msdkMethod,
            scene: scene,
            title: self.opts.title,
            desc: self.opts.desc,
            url: self.opts.url
          };
          msdkShare(JSON.stringify(shareData));
        });
      });
    }
  }
};
export default msdkClient;